"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignFieldToJSON = exports.CampaignFieldFromJSONTyped = exports.CampaignFieldFromJSON = exports.CampaignField = void 0;
/**
 *
 * @export
 */
exports.CampaignField = {
    Id: 'ID',
    Name: 'NAME',
    CreatedAt: 'CREATED_AT',
    UpdatedAt: 'UPDATED_AT',
    Status: 'STATUS',
    PurchaseOrder: 'PURCHASE_ORDER',
    Objective: 'OBJECTIVE',
    MeasurementMetadata: 'MEASUREMENT_METADATA',
    AdProduct: 'AD_PRODUCT',
    Channel: 'CHANNEL',
    SalesforceOpportunity: 'SALESFORCE_OPPORTUNITY',
    DerivedStatus: 'DERIVED_STATUS',
    SalesforceSalesOrder: 'SALESFORCE_SALES_ORDER',
    DeliveryGoalGroup: 'DELIVERY_GOAL_GROUP'
};
function CampaignFieldFromJSON(json) {
    return CampaignFieldFromJSONTyped(json, false);
}
exports.CampaignFieldFromJSON = CampaignFieldFromJSON;
function CampaignFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CampaignFieldFromJSONTyped = CampaignFieldFromJSONTyped;
function CampaignFieldToJSON(value) {
    return value;
}
exports.CampaignFieldToJSON = CampaignFieldToJSON;
